import React, { createContext } from 'react';
import PropTypes from 'prop-types';

const ContainerContext = createContext({});

const ContainerProvider = (props) => {
  const { children, ...valueProps } = props.value; // eslint-disable-line no-unused-vars
  return (
    <ContainerContext.Provider value={valueProps}>
      {props.children}
    </ContainerContext.Provider>
  );
}

ContainerProvider.propTypes = {
  children: PropTypes.any,
  value: PropTypes.object
};

export { ContainerContext, ContainerProvider };
